export function calculateExtent(coordinate, size, map) {
  var view = map.getView()
  var resolution = view.getResolution()
  var devicePixelRatio = window.devicePixelRatio || 1
  var minX = coordinate[0] - resolution * (size[0] * devicePixelRatio) / 2
  var maxX = coordinate[0] + resolution * (size[0] * devicePixelRatio) / 2
  var minY = coordinate[1] - resolution * (size[1] * devicePixelRatio) / 2
  var maxY = coordinate[1] + resolution * (size[1] * devicePixelRatio) / 2
  return [minX, minY, maxX, maxY]
}

export function createExtentFromPixel(map, pixel, size) {
  var extent
  var bufferPixels = size
  var buffer = bufferPixels
  var pixelX = pixel[0]
  var pixelY = pixel[1]

  var pixelBottomLeft = [pixelX - buffer, pixelY + buffer]
  var pixelTopRight = [pixelX + buffer, pixelY - buffer]

  var coordinateBottomLeft = map.getCoordinateFromPixel(pixelBottomLeft)
  var coordinateTopRight = map.getCoordinateFromPixel(pixelTopRight)

  extent = [
    coordinateBottomLeft[0],
    coordinateBottomLeft[1],
    coordinateTopRight[0],
    coordinateTopRight[1]
  ]
  return extent
}
